import { useCallback, useContext, useEffect, useState } from 'react'
import GeoContext from 'contexts/geoContext'
import useFeatureFlag from 'hooks/Experiments/useFeatureFlag'
import { OptimizelyFeatureFlags } from 'constants/featureFlags'
import { isLeLivePromotionGeoState } from 'constants/config/region'
import { getCookies, setCookie } from 'lib/web/cookieUtils'
import { daysInSeconds } from 'lib/datetime/durationInSeconds'

const COOKIE_NAME = 'le_live_prompt_dismissed'
const COOKIE_TTL = daysInSeconds(7)
const ENTRY_DELAY_MS = 2000
const EVENT_EXPIRY_DATE = new Date('2026-05-17T23:59:59+10:00')

// Temporary hardcoded override while Optimizely Production permission is pending.
// Revert to `false` (or remove this constant entirely) once the `le_live_popup` flag is Running in Optimizely Production.
// Tracking: https://app.optimizely.com/v2/projects/24799170005/flags/manage/le_live_popup/rules/production
const HARDCODED_ENABLE_LE_LIVE_POPUP = true

function useLeLivePrompt() {
  const [show, setShow] = useState(false)
  const optimizelyEnabled = useFeatureFlag(OptimizelyFeatureFlags.leLivePopup)
  const isEnabled = HARDCODED_ENABLE_LE_LIVE_POPUP || optimizelyEnabled
  const { geoStateName } = useContext(GeoContext)

  const isVic = isLeLivePromotionGeoState(geoStateName)
  const isExpired = new Date() > EVENT_EXPIRY_DATE
  const isDismissed = typeof window !== 'undefined' && getCookies()[COOKIE_NAME] === 'true'
  const isDevPreview = typeof window !== 'undefined' && window.localStorage.getItem('le_live_popup_preview') === 'true'

  const canShow = isDevPreview || (isEnabled && isVic && !isExpired && !isDismissed)

  useEffect(() => {
    if (!canShow) return
    const timeout = setTimeout(() => setShow(true), ENTRY_DELAY_MS)
    return () => clearTimeout(timeout)
  }, [canShow])

  const dismiss = useCallback(() => {
    setShow(false)
    setCookie(COOKIE_NAME, 'true', COOKIE_TTL, '/', 'Lax')
  }, [])

  return { show, dismiss }
}

export default useLeLivePrompt
